import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=53988b32&"
import script from "./Tools.vue?vue&type=script&lang=js&"
export * from "./Tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53988b32')) {
      api.createRecord('53988b32', component.options)
    } else {
      api.reload('53988b32', component.options)
    }
    module.hot.accept("./Tools.vue?vue&type=template&id=53988b32&", function () {
      api.rerender('53988b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/Tools.vue"
export default component.exports